export default {
  state: {
    status: '',
    commonStateChangeReasons: [],
  },
  mutations: {
    commonStateChangeReason_success(state, commonStateChangeReasons) {
      state.status = 'success';
      state.commonStateChangeReasons = commonStateChangeReasons;
    },
    commonStateChangeReason_error(state) {
      state.status = 'error';
    },
  },
  actions: {
    setCommonStateChangeReasons({commit}, commonStateChangeReasons) {
      commit('commonStateChangeReason_success', commonStateChangeReasons);
    },
  },
  getters: {
    commonStateChangeReasons: (state) => {
      return state.commonStateChangeReasons;
    },
  },
};
